import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import SignupForm from "../views/SignupForm.vue";
import ReviewerGuidelines from "../views/ReviewerGuidelines.vue";

const routes = [
  { path: "/", name: "Home", component: HomePage },
  { path: "/signup", name: "Signup", component: SignupForm },
  { path: "/reviewer-guidelines", name: "ReviewerGuidelines", component: ReviewerGuidelines },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;

